import * as _ from 'lodash';
import { IMatchRunGroup, IMatchRunScenario } from '@nkr/models/index';
import { Button } from 'react-bootstrap';
import { ButtonWrapper } from './styles';

interface IProps {
    groups: IMatchRunGroup[],
    scenarios: IMatchRunScenario[],
    onClear: (bm3: boolean) => void,
    onRunScenario?: (scenario: IMatchRunScenario, rerun: boolean) => void
}

const BestMatchOptions = (props: IProps) => {
    const { groups, scenarios } = props;
    const sortedGroups = _.sortBy(groups, x => x.sortOrder);

    return (
        <>
            <div style={{ marginBottom: 20 }}>
                <ButtonWrapper style={{ display: 'flex', alignItems: 'center' }}>
                    {sortedGroups.map((group, index) => {
                        let groupScenarios = scenarios.filter(x => x.group.id == group.id);

                        return (
                            <div key={'group-' + index} style={{ flexGrow: 1, marginRight: 5, padding: 2, }}>
                                <div style={{ fontSize: 12 }}>{group.name}</div>
                                {groupScenarios.map((groupScenario, groupScenarioIndex) =>
                                    <div className={'scenario-button ' + group.cssClass} key={'gb-' + groupScenarioIndex} title={'Scenario ' + groupScenario.id}><Button block bsSize='sm' onClick={() => props.onRunScenario(groupScenario, false)}>{groupScenario.title}</Button></div>
                                )}
                            </div>
                        );
                    })}
                </ButtonWrapper>
            </div>
        </>
    );
}

export default BestMatchOptions;